import { NIRVIK_LINKEDIN } from '@/lib/linkedin';
import { ReadyMark } from './logo';

const LINKS = [
  { href: 'https://www.nirvik.ai/', label: 'Nirvik AI Labs' },
  { href: 'https://trinetra.nirvik.ai/', label: 'Trinetra' },
  { href: NIRVIK_LINKEDIN, label: 'LinkedIn' },
];

/** Nirvik AI Labs, its Trinetra platform and its LinkedIn page; in every footer. */
export function FooterLinks({ className = '' }: { className?: string }) {
  return (
    <nav aria-label="Nirvik AI Labs" className={className}>
      <ul className="flex flex-wrap items-center justify-center gap-x-5 gap-y-1 lg:flex-nowrap lg:whitespace-nowrap">
        {LINKS.map((l) => (
          <li key={l.href}>
            <a
              href={l.href}
              target="_blank"
              rel="noopener noreferrer"
              className="-my-2 inline-block py-2 underline-offset-2 transition-colors hover:text-foreground hover:underline"
            >
              {l.label}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}

/**
 * The site footer, on the landing page and every app page: the Nirvik Ready
 * mark, the links above and the copyright. `width` lines its edges up with
 * the page's own (the landing page is wider than the app).
 */
export function SiteFooter({ width = 'max-w-5xl px-4' }: { width?: string }) {
  return (
    <footer className="border-t border-border py-4 lg:py-5">
      <div
        className={`mx-auto flex ${width} flex-col items-center justify-between gap-2 lg:flex-row lg:gap-6`}
      >
        <div className="flex flex-wrap items-center justify-center gap-2">
          <ReadyMark className="h-5 w-5 text-primary-strong" />
          <span className="font-display text-sm font-semibold tracking-wide text-muted-foreground">
            Nirvik Ready
          </span>
          <span className="ml-2 text-xs text-muted-foreground/70">
            A{' '}
            <a
              href="https://nirvik.ai"
              className="underline underline-offset-2 transition-colors hover:text-foreground"
            >
              Nirvik AI Labs
            </a>{' '}
            project
          </span>
        </div>
        <FooterLinks className="text-xs text-muted-foreground" />
        <p className="text-center text-xs text-muted-foreground lg:whitespace-nowrap lg:text-right">
          &copy; {new Date().getFullYear()} Nirvik AI Labs. Free for every learner.
        </p>
      </div>
    </footer>
  );
}
